import { Component, Input } from '@angular/core';

@Component({
    selector: 'focus-select',
    templateUrl: './focus-select.component.html',
    styleUrls: ['./focus-select.component.scss'],
    standalone: true,
})
export class FocusSelectComponent {
  @Input() set select(activeFocus: boolean) {
    this.focused = activeFocus;
  }
  focused = false;

  constructor() {}
}
